import React from 'react';
import { stringifyUrl } from 'query-string';
import { VetChatMessage } from '../../../VetChatMessage';
import { Link } from '../../../../../../components/Link';
import { WagWebAppUrl } from '../../../../../../constants/app';
import { QueryStringKeys } from '../../../../../../constants/query-string-keys';
import { theme } from '../../../../../../wag-react/themes/base-theme';
type VetChatCheckoutMessageProps = {
  value?: Record<'name' | 'breed' | 'birthday' | 'weight', string>;
};
export const VetChatCheckoutMessage = ({
  value
}: VetChatCheckoutMessageProps) => {
  const {
    name: petName,
    birthday: petBirthday,
    breed: petBreed,
    weight: petWeight
  } = value;
  const url = stringifyUrl({
    url: WagWebAppUrl.WagHealthVetChatCheckout,
    query: {
      [QueryStringKeys.PetName]: petName,
      [QueryStringKeys.PetBirthday]: petBirthday,
      [QueryStringKeys.PetBreed]: petBreed,
      [QueryStringKeys.PetWeight]: petWeight
    }
  });
  return <VetChatMessage data-sentry-element="VetChatMessage" data-sentry-component="VetChatCheckoutMessage" data-sentry-source-file="index.tsx">
      {`Got it, thanks! A veterinarian professional is standing by to help you and ${petName} further. Sign up for unlimited vet chat to continue the conversation.`}

      <Link href={url} target="_blank" display="block" fontFamily={theme.fonts.muliBold} mt={3} style={{
      textDecoration: 'underline'
    }} data-sentry-element="Link" data-sentry-source-file="index.tsx">
        {'Continue >>'}
      </Link>
    </VetChatMessage>;
};